import { actions as types, mutations } from "./types";
import { Api, ApiUrl } from "../../services";
import i18n from "@/i18n.js";

let transformPageType = originalType => {
  switch (originalType) {
    case "subpages":
      return "template-page";
    case "articlepages":
      return "template-article";
    case "homepages":
      return "template-index";
    case "productpages":
      return "template-product";
    case "collectionpages":
      return "template-collection";
    default:
      return originalType;
  }
};

const actions = {
  [types.FETCH_ANALYTIC]: async (store, query = {}) => {
    store.state.loading = true;

    query.limit = 50;
    query.offset = 0;

    try {
      const { state } = store;
      const url = ApiUrl.base.analytic.listCampaigns;
      const response = await Api.base.get(url, { params: query });
      const {
        data: { campaigns, total }
      } = response;
      state.fetched = true;
      store.commit(mutations.ANALYTIC_FETCH_NEW, { list: campaigns || [], total: total || campaigns.length || 0 });
      Promise.resolve();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      Promise.reject(i18n.t("status.error"));
    }
    store.state.loading = false;
  },

  [types.FETCH_DETAIL_ANALYTIC]: (store, params = { onSuccess: () => {} }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { id, onSuccess } = params;

        if (id) {
          const url = ApiUrl.base.analytic.campaignRUD(id);
          const response = await Api.base.get(url);

          const { campaign, status, message } = response.data;

          if (status == "success") {
            if (onSuccess) onSuccess(campaign);
            store.commit(mutations.ANALYTIC_ATTACH, campaign);
            resolve(campaign);
          } else {
            reject(message);
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      }
    });
  },
  [types.CREATE_NEW_CAMPAIGN_ANALYTIC]: (store, campaign) => {
    return new Promise(async (resolve, reject) => {
      let state = store.state.newCampaign;
      state.status.loading = true;

      try {
        let res = await Api.base.post(ApiUrl.base.analytic.createCampaign, campaign);
        if (res.data && res.data.status == "success") {
          state.status.loading = false;
          state.status.success = true;
          store.commit(mutations.ANALYTIC_APPEND, res.data.campaign);
          resolve(res.data);
          setTimeout(() => {
            state.status.success = false;
          }, 2000);
        } else {
          throw res;
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
        state.status.loading = false;
        state.status.error = true;
        reject(err);
        setTimeout(() => {
          state.status.error = false;
        }, 2000);
      }
    });
  },

  [types.DELETE_CAMPAIGN_ANALYTIC]: (store, { id }) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (id) {
          const url = ApiUrl.base.analytic.campaignRUD(id);
          const res = await Api.base.delete(url);
          store.commit(mutations.ANALYTIC_DELETE_CAMPAIGN, id);
          resolve(res.data);
        } else {
          reject({ message: "ID not defined" });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      }
    });
  },
  [types.START_CAMPAIGN_ANALYTIC]: (store, { id }) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (id) {
          store.commit(mutations.ANALYTIC_UPDATE_CAMPAIGN_INDICATING, { id, status: true });
          const url = ApiUrl.base.analytic.startCampaign(id);
          const res = await Api.base.post(url);
          store.commit(mutations.ANALYTIC_UPDATE_CAMPAIGN_STATUS, { id, status: "running" });
          resolve(res.data);
        } else {
          reject({ message: "ID not defined" });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      } finally {
        store.commit(mutations.ANALYTIC_UPDATE_CAMPAIGN_INDICATING, { id, status: false });
      }
    });
  },
  [types.STOP_CAMPAIGN_ANALYTIC]: (store, { id }) => {
    return new Promise(async (resolve, reject) => {
      try {
        store.commit(mutations.ANALYTIC_UPDATE_CAMPAIGN_INDICATING, { id, status: true });
        if (id) {
          const url = ApiUrl.base.analytic.stopCampaign(id);
          const res = await Api.base.post(url);
          // TODO: status sau khi stop sẽ là từ server trả về
          store.commit(mutations.ANALYTIC_UPDATE_CAMPAIGN_STATUS, { id, status: "on_hold" });
          resolve(res.data);
        } else {
          reject({ message: "ID not defined" });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      } finally {
        store.commit(mutations.ANALYTIC_UPDATE_CAMPAIGN_INDICATING, { id, status: false });
      }
    });
  },
  [types.ADD_VARIANTS_ANALYTIC]: (store, { id, variantIDs, pageType }) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (id) {
          const url = ApiUrl.base.analytic.addVariants(id);
          const res = await Api.base.post(url, { pageType, variantIDs });
          store.commit(mutations.ANALYTIC_ADD_VARIANTS_ATTACH, res.data.data);
          resolve(res.data.data);
        } else {
          reject({ message: "ID not defined" });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      }
    });
  },

  [types.UPDATE_CAMPAIGN_ANALYTIC]: (store, { id, data }) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (id) {
          const attributes = [...Object.keys(data), "updated_at"];
          const url = ApiUrl.base.analytic.campaignRUD(id);
          const res = await Api.base.put(url, { data });
          const campaign = res.data.campaign;
          if (process.env.NODE_ENV == "development") {
            campaign.id = id;
          }
          store.commit(mutations.ANALYTIC_UPDATE_CAMPAIGN, { campaign, attributes, data });
          resolve(res.data);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      }
    });
  },
  [types.UPDATE_PERCENTS_ANALYTIC]: (store, { id, pages }) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (id) {
          const url = ApiUrl.base.analytic.addVariants(id);
          const res = await Api.base.put(url, { pages });
          const variants = res.data.pages;
          const _variants = pages.map(x => ({ id: x.g_id, value: x.value }));
          store.commit(mutations.ANALYTIC_UPDATE_PERCENT_ATTACH, { id, variants: variants || _variants });
          resolve(res.data);
        } else {
          reject({ message: "ID not defined" });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      }
    });
  },
  [types.DELETE_VARIANT_ANALYTIC]: (store, { campaignID, variantID }) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (campaignID && variantID) {
          const url = ApiUrl.base.analytic.variantRUD(campaignID, variantID);
          const res = await Api.base.delete(url);
          store.commit(mutations.ANALYTIC_DELETE_CAMPAIGN_VARIANT, { campaignID, variantID });
          resolve(res.data);
        } else {
          reject({ message: "ID not defined" });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      }
    });
  },
  [types.UPDATE_VARIANT_ANALYTIC]: (store, { campaignID, variantID, data }) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (campaignID && variantID) {
          const url = ApiUrl.base.analytic.variantRUD(campaignID, variantID);
          const res = await Api.base.put(url, data);
          store.commit(mutations.ANALYTIC_UPDATE_CAMPAIGN_VARIANT, { campaignID, variantID, data: data.data });
          resolve(res.data);
        } else {
          reject({ message: "ID not defined" });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      }
    });
  },

  [types.GET_REPORT_ANALYTIC]: (store, params = { onSuccess: function() {}, id: null, date: "" }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { id, onSuccess } = params;

        if (id) {
          const url = ApiUrl.base.analytic.report(id);
          const query = {};
          if (params.date && params.date.length) {
            query.date = params.date;
          }
          const response = await Api.base.get(url, { params: query });

          const { pages, status, message } = response.data;

          if (status == "success") {
            if (onSuccess) onSuccess(pages);
            // store.commit(mutations.ANALYTIC_ATTACH, pages);
            resolve(pages);
          } else {
            reject({ message });
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      }
    });
  },
  [types.FETCH_ACCOUNTS_ANALYTIC]: store => {
    return new Promise(async (resolve, reject) => {
      const { state } = store;
      if (state.accounts.fetched) {
        resolve(state.accounts.list);
        return state.accounts.list;
      }
      try {
        const url = ApiUrl.base.analytic.getAccounts;
        const response = await Api.base.get(url);
        const { accounts, status, message } = response.data;

        if (status == "success") {
          store.commit(mutations.ANALYTIC_FETCH_ACCOUNTS, accounts);
          resolve(accounts);
        } else {
          reject({ message });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      }
    });
  },
  [types.FETCH_PROPERTIES_ANALYTIC]: (store, { id, isGA4 }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = isGA4 
          ? ApiUrl.base.analytic.getPropertiesGA4(id) 
          : ApiUrl.base.analytic.getProperties(id);

        const response = await Api.base.get(url);
        const { properties, status, message } = response.data;

        if (status == "success") {
          resolve(properties);
        } else {
          reject({ message });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      }
    });
  },
  [types.FETCH_PROFILES_ANALYTIC]: (store, { accountID, propertyID }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = ApiUrl.base.analytic.getProfiles(accountID, propertyID);
        const response = await Api.base.get(url);
        const { views, status, message } = response.data;

        if (status == "success") {
          resolve(views);
        } else {
          reject({ message });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      }
    });
  },
  [types.FETCH_STREAMS_ANALYTIC]: (store, { accountID, propertyID }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = ApiUrl.base.analytic.getStreams(accountID, propertyID);
        const response = await Api.base.get(url);
        const { streams, status, message } = response.data;

        if (status == "success") {
          resolve(streams);
        } else {
          reject({ message });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      }
    });
  },
  [types.CLONE_PAGE_ANALYTIC]: (store, { campaignID, page }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const type = page.g_type;
        const params = {
          pageType: transformPageType(type)
        };
        const res = await Api.base.post(ApiUrl.base.analytic.clone(campaignID, page.g_id), params);
        const thumbnail = page.thumbnail_url;
        if (res && res.data && res.data.status == "success") {
          let page = res.data.data;
          page.thumbnail_url = thumbnail;
          page.__justUpdated = true;
          page.is_main_page = false;
          store.commit(mutations.ANALYTIC_ADD_VARIANTS_ATTACH, [page]);

          resolve(page);
        } else {
          reject(res.data);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      }
    });
  }
};

export default actions;
